// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1wTiP","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2Yz8O"};